module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "lock-closed.59f9256b.svg";